const ModalTransactionInProgress = () => {
    return (
        <div className="trans-updates">
            <img src="/img/payments/payment-progress.svg" alt=""/>
            <span className="f-medium f-20 block m-lg-t">Your payment is in progress.</span>
        </div>
    );
};

export default ModalTransactionInProgress;
